import {FiltroArrendamento} from './../../../models/arrendamento/filtro-arrendamento.model';
import {TipoFiltro} from './../../../models/arrendamento/tipo-filtro.enum';
import {Component, EventEmitter, Output} from "@angular/core";

@Component({
    selector: 'filtro-historico',
    templateUrl: 'filtro-historico-contrato-arrendamento.component.html',
    styleUrls: ['filtro-historico-contrato-arrendamento.component.scss']
})
export class FiltroHistoricoContratoArrendamentoComponent{

    @Output()
    onFilterChangeEmitter = new EventEmitter<FiltroArrendamento>();

    filtro: FiltroArrendamento = {
        valorPesquisa: '',
        tipoFiltro: TipoFiltro.PLACA 
    } 
    

    onFilter() {
        let filtro: FiltroArrendamento = {
            tipoFiltro: this.filtro.tipoFiltro,
            valorPesquisa: this.filtro.valorPesquisa
        }

        if (this.filtro.tipoFiltro !== TipoFiltro.PLACA) {
            filtro.valorPesquisa = this._cpfSanitizer(this.filtro.valorPesquisa)
        }

        this.onFilterChangeEmitter.emit(filtro);
    }

    onFilterChange() {
        this.filtro.valorPesquisa = '';
    }

    cpfChangeHandler(cpf: string) {
        this.filtro.valorPesquisa = cpf;
    }
    
    private _cpfSanitizer(value: string) {
        return value.replace(/[^0-9]+/g, '');
    }

}
